import { Loader } from "../../../components/loader";
import { Amount } from "../../../components/widget/text-widget";
import { useFetchable } from "../../../store/common/fetchable";
import { Wallets } from "../../../store/wallets/reducer";
import { WalletsRoutes } from "../../wallets/routes";
import { StyledTextWidget } from "./common";

export const UnverifiedWalletsTile = () => {
  const walletsSummaryFetchable = useFetchable(Wallets.walletsSummary);

  return (
    <Loader data={[walletsSummaryFetchable]}>
      {([walletsSummary]) => (
        <StyledTextWidget
          title="Unverified Wallets:"
          to={WalletsRoutes.names.walletList}
        >
          <Amount>{walletsSummary.unverifiedWalletsCount}</Amount> wallets
        </StyledTextWidget>
      )}
    </Loader>
  );
};
